/* eslint-disable @typescript-eslint/no-unused-vars */

import { FC, useState } from "react";
import {
  AppCSS,
  Lbl,
  Spacer,
} from "../../../../components";
import { RowDiv, ColDiv } from "../../../../components/misc/misc.styled";
import { CustomerProjectDetails } from "../../../../redux/types/projectDetails";
import { Box } from "@mui/material";

interface InstallationProps {
  project?: CustomerProjectDetails;
}

export const InstallationDetails: FC<InstallationProps> = ({ project }) => {
  const [isEdit, setIsEdit] = useState(false);

  const createDate = (date: string) => {
    const newDate = new Date(date);

    return newDate.toDateString();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {/* Date Display */}
        <Box>
          {project?.installationDetails?.fromDate && project?.installationDetails?.toDate ? (
            <>
              <Box sx={{ fontSize: 16, fontWeight: 600, color: "#1f2937", marginBottom: 1 }}>
                Date Range
              </Box>
              <Box sx={{ fontSize: 14, color: "#374151" }}>
                {createDate(project.installationDetails.fromDate)} - {createDate(project.installationDetails.toDate)}
              </Box>
            </>
          ) : project?.installationDetails?.installationDate?.length > 0 ? (
            <>
              <Box sx={{ fontSize: 16, fontWeight: 600, color: "#1f2937", marginBottom: 1 }}>
                Installation Date
              </Box>
              <Box sx={{ fontSize: 14, color: "#374151" }}>
                {createDate(project.installationDetails.installationDate)}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                fontSize: 14,
                color: "#6b7280",
                padding: 3,
                textAlign: "center",
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
              }}
            >
              Date hasn't been selected by customer yet.
            </Box>
          )}
        </Box>

        {/* Remarks Display */}
        {project?.installationDetails?.remarks && (
          <Box>
            <Box sx={{ fontSize: 16, fontWeight: 600, color: "#1f2937", marginBottom: 1 }}>
              Remarks
            </Box>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                fontSize: 14,
                color: "#374151",
                lineHeight: 1.6,
              }}
            >
              {project.installationDetails.remarks}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
